module.exports = __webpack_public_path__ + "static/img/banner-font.3bb5922.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/draw/banner-font.png
// module id = fCJf
// module chunks = 1